// A cited Slack day, shown as the conversation the agent read rather than as the
// day document's plain text: authors, times, the cited words marked, links to Slack.
import { useEffect, useRef } from "react";

import { useSlackDayDocument } from "../api/hooks/useSlack";
import { SlackMessageList } from "./SlackMessageList";
import modal from "./SourceTextModal.module.css";

export const SlackDayModal = ({
  globalDataId,
  quote,
  onClose,
}: {
  globalDataId: string;
  quote: string | null;
  onClose: () => void;
}) => {
  const ref = useRef<HTMLDialogElement | null>(null);
  const day = useSlackDayDocument(globalDataId);

  useEffect(() => {
    const dialog = ref.current;
    if (dialog && !dialog.open) dialog.showModal();
  }, []);

  return (
    <dialog
      ref={ref}
      className={modal.dialog}
      onCancel={(e) => {
        e.preventDefault();
        onClose();
      }}
      onClose={onClose}
    >
      <div className={modal.body}>
        <div className={modal.headerRow}>
          <div>
            <h2 className={modal.heading}>{day.data?.title ?? "Slack"}</h2>
            {day.data?.channel.is_ext_shared && (
              <p className={modal.subhead}>Shared with another organisation</p>
            )}
          </div>
          <button type="button" className={modal.btnClose} onClick={onClose}>
            Close
          </button>
        </div>
        {day.isLoading && <p className={modal.status}>Loading messages…</p>}
        {day.isError && (
          <div className={modal.error}>Could not load this Slack day. Try again in a moment.</div>
        )}
        {day.data && (
          <SlackMessageList messages={day.data.messages} quote={quote} />
        )}
      </div>
    </dialog>
  );
};
